import { render, staticRenderFns } from "./CampaignRewardMessageSeeAll.vue?vue&type=template&id=b4a36cf0&"
import script from "./CampaignRewardMessageSeeAll.vue?vue&type=script&lang=js&"
export * from "./CampaignRewardMessageSeeAll.vue?vue&type=script&lang=js&"
import style0 from "./CampaignRewardMessageSeeAll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports